import { OrgType } from '@core/api/tenant/tenant.enums';

import { OrgTypeStoreModelEnum } from './tenant.enums';

export const mapOrgTypeApiModelEnumToStoreModelEnum = (orgType: OrgType): OrgTypeStoreModelEnum => {
  return {
    [OrgType.System]: OrgTypeStoreModelEnum.System,
    [OrgType.Operator]: OrgTypeStoreModelEnum.Operator,
  }[orgType];
};
